/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable max-len */
/* eslint-disable react/style-prop-object */
import React, {
    useState, useEffect, useCallback, useContext,
} from 'react';
import { motion } from 'framer-motion';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { distributorService } from '../../../service/distributor.service';
import AreaListSkeleton from './AreaListSkeleton';
import HeaderContext from '../../../Components/Context/HeaderContext';
import EmptyScreen from '../../../Components/GlobalEmplyPage';
import Pagination from '../../../Components/Pagination';
import { PriceHandler } from '../../../redux/helper/CamelCase';
import FilterModal from './FilterModal';

function AreaWiseCustomerOutstandingReport() {
    const {
        isPopup,
        setisPopup,
        ErrorMessage,
        SetErrorMessage,
        SuccessMessage,
        SetSuccessMessage,
        colorValue,
        setcolorValue,
    } = useContext(HeaderContext);
    const navigate = useNavigate();
    const [AreaWiseCustomerList, setAreaWiseCustomerList] = useState([]);
    const [sortType, setsortType] = useState('area_total+desc');
    const [currentPage, setCurrentPage] = useState(1);
    const [searchValue, setsearchValue] = useState('');
    const [totalPage, setTotalPage] = useState('');
    const [alldata, setalldata] = useState({});
    const [loading, setLoading] = useState(true);
    const [emptyData, setEmptyData] = useState(false);
    const [filterModal, setFilterModal] = useState(false);
    const [filterValue, setfilterValue] = useState('');
    const [Filter, setFilter] = useState({
        area_name: [],
        area_total: [],
    });
    const [priceRange, setpriceRange] = useState({
        minValue: 0,
        maxValue: 0,
    });
    const [exportClick, setexportClick] = useState(false);
    const [exportSelected, setexportSelected] = useState('');

    const handleFetchAreaCustomerOutstandingReport = useCallback((() => {
        distributorService.MISAreaWiseOutstandingReport(currentPage, sortType, searchValue, filterValue).then((response) => {
            if (response.error === false && response.data.success_status === true) {
                if (response.data.data.length === 0) {
                    setLoading(false);
                    setEmptyData(true);
                } else {
                    setEmptyData(false);
                    setLoading(false);
                }
                setLoading(false);
                setAreaWiseCustomerList(response.data.data);
                setalldata(response);
                setCurrentPage(response.data.current_page);
                setTotalPage(response.data.number_of_pages);
            } else {
                setLoading(false);
                setalldata([]);
            }
        });
    }), [currentPage, searchValue, sortType, filterValue]);

    const handlePageClick = async (data) => {
        setLoading(false);
        const page = data.selected + 1;
        setCurrentPage(page);
    };

    const handleFilter = (filterUrl) => {
        if (filterUrl.length > 0 && filterValue !== filterUrl) {
            setLoading(true);
            setCurrentPage(1);
            setfilterValue(filterUrl);
        } else {
            setLoading(false);
            setfilterValue(filterUrl);
        }
    };

    const handleView = async (item) => {
        navigate(`/mis-reports/specific-area-wise-customer-outstanding-report/${item.AREA_CODE}`);
    };

    const handleExport = useCallback((() => {
        distributorService.MISAreaWiseOutstandingReport(currentPage, sortType, searchValue, filterValue, exportSelected).then((val) => {
            if (val.data.success_status) {
                // setshowPopup(true);
                SetSuccessMessage(val.data.message);
                setexportClick(false);
                setexportSelected('');
                window.open(val.data.url, '_blank');
                setTimeout(() => {
                    // settitle('');
                    SetSuccessMessage('');
                }, 2000);
            }
        });
    }), [exportSelected]);

    useEffect(() => {
        if (exportSelected !== '') {
            handleExport();
        }
    }, [handleExport]);

    useEffect(() => {
        handleFetchAreaCustomerOutstandingReport();
    }, [handleFetchAreaCustomerOutstandingReport]);

    return (
        <div className="py-6 pr-[18px] main-screen">
            <div className="flex justify-between pb-[18px]">
                <h5 className="text-xs4 font-normal text-[#555259]">Area Wise Customer Outstanding Report</h5>
                <div className="flex">
                    <button
                        type="button"
                        className="bg-[#F5F5FA] font-bold text-xs h-9 text-[#555259] border-2 border-[#E9EDF4] py-1 px-4 rounded-[9px] mr-2.5"
                        style={{
                            border: '2px solid #E9EDF4',
                        }}
                        data-bs-toggle="modal"
                        data-bs-target="#filtermodal"
                        onClick={() => setFilterModal(true)}
                    >
                        Filter
                    </button>
                    <div className="relative mr-2">
                        <label htmlFor="search" />
                        <input
                            type="text"
                            name="search"
                            id="search"
                            className="w-[230px] h-[35px] bg-[#FFFFFF] rounded-lg outline-0 shadow-s3 text-xs2 font-semibold text-[#808285] placeholder:font-semibold placeholder:text-xs2 placeholder:text-[#808285] pl-[35px] pr-[15px]"
                            placeholder="Search"
                            value={searchValue}
                            onChange={(e) => {
                                setsearchValue(e.target.value);
                                setCurrentPage(1);
                            }}
                            autoComplete="off"

                        />
                        <img src="/images/Group-279.svg" alt="icon" className="absolute top-3 left-[15px] cursor-pointer" />
                    </div>
                    <div className="mr-2 dropdown relative">
                        <button
                            type="button"
                            id="exportDropdown"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            className="dropdown-toggle h-[35px] text-xs2 font-semibold text-[#555259] w-[79px] border border-[#555259] rounded-lg"
                            onClick={() => setexportClick(!exportClick)}
                        >
                            Export
                        </button>
                        <ul className={`dropdown-menu min-w-[83px] absolute ${exportClick === true ? 'show' : 'hidden'} bg-[#FFFFFF] rounded-lg shadow-s2 z-[9999]`} aria-labelledby="exportDropdown">
                            <li className="mx-[18px] pb-1.5 mt-5 hover:bg-[#F2F2F3] hover:rounded export">
                                <a
                                    className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block px-1.5 py-0.5"
                                    href="#"
                                    onClick={() => {
                                        setexportSelected('csv');
                                    }}
                                >
                                    CSV
                                </a>
                            </li>
                            <li className="mx-[18px] pb-1.5 hover:bg-[#F2F2F3] hover:rounded">
                                <a
                                    className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block px-1.5 py-0.5"
                                    href="#"
                                    onClick={() => setexportSelected('pdf-converter')}
                                >
                                    PDF

                                </a>
                            </li>
                            <li className="mx-[18px] pb-1.5 mb-3 hover:bg-[#F2F2F3] hover:rounded">
                                <a
                                    className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block px-1.5 py-0.5"
                                    href="#"
                                    onClick={() => setexportSelected('excel')}
                                >
                                    Excel

                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            {loading ? <AreaListSkeleton /> : (
                <div>
                    {AreaWiseCustomerList.length > 0 && (
                        <div
                            className="overflow-auto dropdown-menu pb-7 relative z-10"
                            style={{ height: 'calc(100vh - 298px)' }}
                        >
                            <table className="w-full table-auto relative">
                                <thead className="sticky top-0 left-0 z-[2]">
                                    <tr className="bg-[#555259] h-10">
                                        <th className="py-2.5 px-6 rounded-bl-lg rounded-tl-lg min-w-[171px] sticky top-0 left-0 bg-[#555259]" scope="col">
                                            <span className="text-xs5 font-bold text-[#FFFFFF]">
                                                Area Name
                                            </span>
                                        </th>
                                        <th scope="col" className="py-2.5 px-7 min-w-[168px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                Area Code
                                            </span>
                                        </th>
                                        <th scope="col" className="py-2.5 px-7 min-w-[250px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                Area Total
                                                <a href="#" className="pl-[5px]">
                                                    <motion.img
                                                        animate={{ rotate: sortType === 'area_total+asc' ? 180 : 0 }}
                                                        className={`${sortType === 'area_total+desc' ? 'image-rotate' : ''}`}
                                                        src="/images/sort.svg"
                                                        alt="icon"
                                                        onClick={() => {
                                                            if (sortType === 'area_total+asc') {
                                                                setsortType('area_total+desc');
                                                            } else if (sortType === 'area_total+desc') {
                                                                setsortType('area_total+asc');
                                                            } else {
                                                                setsortType('area_total+asc');
                                                            }
                                                            // setCurrentPage(1);
                                                            // setisLoaded(true);
                                                        }}
                                                    />
                                                </a>
                                            </span>
                                        </th>
                                        <th scope="col" className="py-2.5 px-7 min-w-[152px] rounded-tr-lg rounded-br-lg sm:sticky top-0 right-0 bg-[#555259]" />
                                    </tr>
                                </thead>
                                <tbody>
                                    {AreaWiseCustomerList.length > 0 && AreaWiseCustomerList.map((item) => (
                                        <tr className="bg-[#FFFFFF] border-b border-[#DFEAF7]">
                                            <td
                                                className="text-sm font-normal text-[#090406] py-2.5 px-7 sticky left-0 flex justify-center items-center pt-4"
                                                style={{
                                                    background: 'rgba(255, 255, 255, 0.45)',
                                                    backdropFilter: 'blur(5.5px)',
                                                }}
                                            >
                                                {item?.AREA_NAME}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">
                                                {item?.AREA_CODE}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] text-center py-2.5 px-7">
                                                {PriceHandler(item?.AREA_TOATL)}
                                            </td>
                                            <td
                                                className="py-2.5 px-7 sm:sticky right-0 z-[1]"
                                                style={{
                                                    background: 'rgba(255, 255, 255, 0.45)',
                                                    backdropFilter: 'blur(5.5px)',
                                                }}
                                            >
                                                <div className="flex items-center justify-center">
                                                    <button
                                                        type="button"
                                                        className="font-semibold text-sm text-white bg-[#44445E] rounded-lg w-[72px] h-[34px]"
                                                        onClick={() => handleView(item)}
                                                        style={{
                                                            background: '#44445E',
                                                            padding: '5px 10px',
                                                            borderRadius: '4px',
                                                        }}
                                                    >
                                                        View
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>

                                    ))}

                                </tbody>
                            </table>
                        </div>
                    )}
                    {!loading && AreaWiseCustomerList && AreaWiseCustomerList.length > 0 && (
                        <Pagination
                            handlePageClick={handlePageClick}
                            totalPage={totalPage}
                            List={alldata}
                            currentPage={currentPage}
                        />
                    )}

                    {filterModal && (
                        <FilterModal
                            handleFilter={handleFilter}
                            filterModal={filterModal}
                            setFilterModal={setFilterModal}
                            AreaWiseCustomerList={AreaWiseCustomerList}
                            setAreaWiseCustomerList={setAreaWiseCustomerList}
                            Filter={Filter}
                            setFilter={setFilter}
                            filterValue={filterValue}
                            setfilterValue={setfilterValue}
                            handleFetchAreaCustomerOutstandingReport={handleFetchAreaCustomerOutstandingReport}
                            setpriceRange={setpriceRange}
                            priceRange={priceRange}
                            SetSuccessMessage={SetSuccessMessage}
                        />
                    )}

                    {emptyData && (
                        <EmptyScreen
                            search="yes"
                            all={searchValue !== '' ? 'under searched term' : 'found'}
                            text=" no Area Wise Customer Outstanding Report"
                            buttonRequired={false}
                        />
                    )}

                </div>
            )}

        </div>
    );
}

export default AreaWiseCustomerOutstandingReport;
